import React from "react";
import styled from "styled-components";
import {Button} from "antd";
import {useNavigate} from "react-router-dom";
import {observer} from "mobx-react";

const headerLogo = require("../../src/image/header-logo.png")

interface HeardProps {
    isLogin?:boolean;
    userName?:string;
    showLogin?:boolean;
    showBack?:boolean;
}

const CommonHeader: React.FC<HeardProps> = ({isLogin= false, userName, showLogin = true, showBack = false}) => {

    const navigateTo = useNavigate();
    const toLogin = () => {
      localStorage.removeItem('token');
      navigateTo("/login")
    }
    const logout = () => {
      localStorage.removeItem('token');
      navigateTo("/home");
    }
    return (<Wrapper>
        <LogoImg src={headerLogo}/>
        <RightWrapper>
            {showLogin && <LoginButtonWrapper onClick={isLogin? logout : toLogin} >{isLogin? "退出登录":"登录"}</LoginButtonWrapper>}
            {isLogin && userName && <span style={{fontSize:"15px" ,color:"#000000",alignSelf: "center", marginRight: "30px"}}>{userName}</span>}
        </RightWrapper>
    </Wrapper>);
}
export default observer(CommonHeader);
const Wrapper = styled.div`
  & {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 88px;
    background: white;
    color: #F9F9F9;
  }
`;

const RightWrapper = styled.div`
  & {
    position: fixed;
    right: 0;
    align-self: center;
    Button {
      margin-right: 30px;
    }
  }
`;
const LoginButtonWrapper = styled.button`
  & {
    font-size: 15px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    background: #fff;
    color: #333;
    align-self: center;
    width: 80px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid #ccc;
    text-align: center;
    margin-right: 30px;
    cursor: default;
    :hover{
      border: 1px solid #1990FF;
      color: #1990FF;
    }
  }
`;
const LogoImg = styled.img`
    & { 
      width: auto;
      height: 88px;
      align-self: center;
      margin-left: 38px;
    }
`;